import * as React from "react"

function SvgCurrencyEuroCircle(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 21 20"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.833}
      >
        <path d="M10.003.417c5.293 0 9.584 4.29 9.584 9.583s-4.291 9.583-9.584 9.583C4.711 19.583.42 15.293.42 10S4.71.417 10.003.417z" />
        <path d="M12.083 14.583c-2.991 0-5.416-.833-5.416-4.583s2.425-4.583 5.416-4.583M5.42 11.25h4.583M5.42 9.583h5.417" />
      </g>
    </svg>
  )
}

export default SvgCurrencyEuroCircle
